import React, { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import DashboardConsorcioBigNumbers from "./dashboardConsorcio-bignumbers/DashboardConsorcioBigNumbers";
import DashboardConsorcioCompararEconomia from "./dashboardConsorcio-comparar-economia/DashboardConsorcioEconomia";
import { DashboardConsorcioFilter } from "./dashboardConsorcio-filter/DashboardConsorcioFilter";
import DashboardConsorcioHeader from "./dashboardConsorcio-header/DashboardConsorcioHeader";
import DashboardConsorcioHistorico from "./dashboardConsorcio-historico/DashboardConsorcioHistorico";
import DashboardConsorcioTable from "./dashboardConsorcio-table/DashboardConsorcioTable";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DashboardConsorcioHeaderNotificacoes from "./dashboardConsorcio-header/DashboardConsorcioHeaderNotificacoes";
// import DashboardConsorcioAmbiente from "./dashboardFinanceiro-ambiente/DashboardConsorcioAmbiente";

export function DashboardConsorcioCard() {
  const {
    bigNumbers,
    bigNumbersUltimoMes,
    grafico,
    historicoEconomia,
    notificacoesLead
  } = useSelector(
    state => ({
      bigNumbers: state.dashboardConsorcio.bigNumbers,
      bigNumbersUltimoMes: state.dashboardConsorcio.bigNumbersUltimoMes,
      grafico: state.dashboardConsorcio.grafico,
      historicoEconomia: state.dashboardConsorcio.historicoEconomia,
      notificacoesLead: state.dashboardConsorcio.notificacoesLead
    }),
    shallowEqual
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if(notificacoesLead == null){
      setFase(2)
    }
  }, [notificacoesLead, dispatch]);
  
  const [fase, setFase] = useState(1)
  const [clienteCombo, setClienteCombo] = useState([]);
  return (
    <>
      {/* {fase == 1 && ( */}
        <>
          {/* <Header />
          <div className="bg-backgroundMain pt-2 pb-4">
            <section className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-7 gap-3 my-10">
                <div className="md:col-span-7 gap-3">
                  <DashboardConsorcioHeaderNotificacoes />
                </div>
               </div>
            </section>
          </div>
          <Footer /> */}
        </>
      {/* )}
      {fase == 2 && ( */}
        <>
          <Header />
          <div className="bg-backgroundMain pt-2 pb-4">
            <section className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-7 gap-3 my-10">
                <div className="md:col-span-7 gap-3">
                  <DashboardConsorcioHeader data={{ bigNumbers }} />
                  <div className="bg-white p-4 rounded-lg shadow-md mt-3">
                    <DashboardConsorcioFilter />
                  </div>
                </div>
                <div className="md:col-span-5 flex flex-col gap-3 z-0">
                  <DashboardConsorcioBigNumbers
                    data={{ bigNumbers, bigNumbersUltimoMes }}
                  />
                  <DashboardConsorcioCompararEconomia data={grafico} />
                </div>
                <div className="md:col-span-2 -z-10">
                  <DashboardConsorcioHistorico data={historicoEconomia} />
                </div>
                <div className="md:col-span-7 gap-3">
                  <DashboardConsorcioTable />
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </>
      {/* )} */}
    </>
  );
}
